import "./App.css";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { WhatIsSection } from "./components/WhatIsSection";
import HomeBeforeAfterSection from "./components/HomeBeforeAfterSection";
import { ServicesSection } from "./components/ServicesSection";
import { BenefitsSection } from "./components/BenefitsSection";
import { FAQSection } from "./components/FAQSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Listedepirx from "./pages/Listedepirx";
import ASavoir from "./pages/ASavoir";
import AvisAuxUtilisateurs from "./pages/AvisAuxUtilisateurs";
import AiPreview from "./pages/AiPreview";
import ScrollToHashHandler from "./components/ScrollToHashHandler";
import ServiceReemaillage from "./pages/ServiceReemaillage";
import RouteSeo from "./components/RouteSeo";
import { captureLeadAttribution } from "./lib/leadAttribution";

function App() {
  useEffect(() => {
    captureLeadAttribution();
  }, []);

  useEffect(() => {
    const handleTelClick = (e) => {
      const link = e.target.closest('a[href^="tel:"]');
      if (!link) return;

      const phoneHref = link.getAttribute("href");
      if (!phoneHref) return;

      e.preventDefault();

      if (typeof window.gtag === "function") {
        window.gtag("event", "click_call", {
          event_category: "engagement",
          event_label: phoneHref,
        });
      } else if (window.dataLayer) {
        window.dataLayer.push({
          event: "click_call",
          event_category: "engagement",
          event_label: phoneHref,
        });
      }

      setTimeout(() => {
        window.location.href = phoneHref;
      }, 300);
    };

    document.addEventListener("click", handleTelClick);

    return () => {
      document.removeEventListener("click", handleTelClick);
    };
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <RouteSeo />
        <div
          className="min-h-screen flex flex-col bg-white text-slate-900 dark:bg-[#070b12] dark:text-slate-100"
          data-testid="app-container"
        >
          <Navbar />

          <main className="flex-1">
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <ScrollToHashHandler />
                    <HeroSection />
                    <WhatIsSection />
                    <HomeBeforeAfterSection />
                    <ServicesSection />
                    <BenefitsSection />
                    <TestimonialsSection />
                    <FAQSection />
                    <ContactSection />
                  </>
                }
              />
              <Route path="/liste-de-prix" element={<Listedepirx />} />
              <Route path="/service-de-reemaillage" element={<ServiceReemaillage />} />
              <Route path="/listedeprix" element={<Navigate to="/liste-de-prix" replace />} />
              <Route path="/listedepirx" element={<Navigate to="/liste-de-prix" replace />} />
              <Route path="/a-savoir" element={<ASavoir />} />
              <Route path="/avis-aux-utilisateurs" element={<AvisAuxUtilisateurs />} />
              <Route path="/ai-preview" element={<AiPreview />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
